import { useState } from 'react';
import { Link } from 'react-router-dom';
import Services from '../../Services/services';

export const EmailInput = ({
  email,
  setEmail,
  setUserExists,
  setClientExists,
  setClientId,
}) => {
  const [emailError, setEmailError] = useState('');

  const checkForEmail = async () => {
    if (!email) {
      return;
    }

    const userEmail = await Services.userService.checkForEmail(email);

    if (userEmail) {
      setClientExists(true);
      setUserExists(true);
    } else {
      const clientEmail = await Services.profileService.checkForEmail(email);
      if (clientEmail) {
        const clientId = await Services.profileService.clientByEmail(email);
        setClientId(clientId);
        setClientExists(true);
        setUserExists(false);
      } else {
        setEmailError('Aucun compte ne correspond à cette adresse email');
        setUserExists(false);
        setClientExists(false);
      }
    }
  };

  const handleEmailSubmit = (e) => {
    e.preventDefault();
    checkForEmail();
  };

  return (
    <>
      <span className="login-subtitle">
        <i>
          Première connexion ? Renseignez l'adresse e-mail utilisée lors de la
          création des devis.
        </i>
      </span>
      <form className="login-container" onSubmit={handleEmailSubmit}>
        <div className="mail-container relative-container">
          <input
            type="email"
            id="email"
            name="email"
            className="contact-form-input"
            autoComplete="username"
            onChange={(e) => setEmail(e.target.value)}
            value={email}
            required
          />
          <label htmlFor="email" className="contact-form-label">
            Adresse email
          </label>
        </div>
        {emailError && <p style={{ color: 'red' }}>{emailError}</p>}
        <Link to="/forgot-password" className="login-forgot-password">
          Mot de passe oublié
        </Link>
        <button type="submit" className="btn-create-account">
          Continuer
        </button>
      </form>
    </>
  );
};
